/** Cache in-memory URL anteprime già caricate (sessione tab). */
const loadedUrls = new Set();
const failedUrls = new Set();

export function markSocialThumbLoaded(url) {
  if (url) {
    loadedUrls.add(url);
    failedUrls.delete(url);
  }
}

export function markSocialThumbFailed(url) {
  if (url) {
    failedUrls.add(url);
    loadedUrls.delete(url);
  }
}

export function isSocialThumbCached(url) {
  return Boolean(url && loadedUrls.has(url));
}

export function isSocialThumbFailed(url) {
  return Boolean(url && failedUrls.has(url));
}
